import * as React from 'react';
import { PackageType } from '../../classes/package-listing';

import { CombinedPackageViewProps } from '../../components/list/package';
import ListPerformances from '../../components/list/performances';

const ListPackageView: React.StatelessComponent<CombinedPackageViewProps> = props => {
    function removeCart() {

        if (props.alternatePackageSelected) {
            props.removeItemFromCart(props.selectedPackageId, true)
        }
        else {
            props.removeItemFromCart(props.package.id, false)
        }
        props.disableAllSeries(false);
    }

    const selectSubscriptionButton = (
        <button className="btn"
            disabled={(props.reachedMaxQuantity || props.disableSeriesButtons) && !props.selectedPackage && !props.alternatePackageSelected ? true : false}
            onClick={() => {
                const unseated = props.settings.useUnseatedReservation;
                props.selectedPackage || props.alternatePackageSelected
                    ? removeCart()
                    : props.selectPackage(props.package, unseated, props.package.packageType === PackageType.Fixed)
            }}>
            {props.selectedPackage || props.alternatePackageSelected ? props.text.removeButtonText : props.text.selectSubscriptionButtonText}
        </button>
    );

    return (
        <li
            key={props.package.id}
            data-package-id={props.package.id}
            className={`ace-subs-item ${props.matchesCurrentRenewalPackage ? "ace-subs-item-renewal" : ""} ${!props.showPackage ? "hide" : ""}`}
            aria-hidden={!props.showPackage}
        >
            <article className="ace-subs-package">
                <div className="ace-layout ace-layout-2-eq ace-layout-borderless-mobile">
                    <div>
                        <div className="ace-subs-package-img">
                            <img src={props.package.packageImageUrl ?? props.defaultPackageImageUrl} alt="" />
                        </div>
                    </div>
                    <div>
                        <div className="ace-subs-package-details">
                            <div className="ace-subs-package-details-upper">
                                <div>
                                    {
                                        props.matchesCurrentRenewalPackage &&
                                        <p className="ace-subs-package-preheader">
                                            {props.text.renewalCurrentSubscriptionPreTitleText}
                                        </p>
                                    }

                                    <h2 className="h3-style">{props.package.title}</h2>
                                </div>

                                {
                                    // check to see if there is only one package (then it doesn't make sense to be able to remove it)
                                    // or if this is a renewal, we don't show the show select button when there is already a package selected,
                                    // since we limit the max qty to 1 for renewals
                                    (props.numberOfPackagesInList == 1 && props.selectedPackage) || !props.showSelectButton
                                        ? null
                                        : selectSubscriptionButton
                                }
                            </div>

                            <div>
                                <p className="bold">{props.package.numberOfPerformancesMessage}</p>

                                {
                                    props.package.description ?
                                        <p data-demo-label="Package Description">
                                            {props.package.description}
                                        </p>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item space-top-lg">
                    <button className="accordion-trigger accordion-trigger-alt"



                        onClick={(e) => {
                            props.toggleShowPerformances(e)
                        }} aria-expanded={props.showPerformances} aria-controls={`Panel_package_${props.package.id}`}>
                        {
                            props.showPerformances
                                ? props.text.hidePerformancesButtonText
                                : props.text.viewPerformancesButtonText
                        }
                        {
                            props.package.numberOfPerformancesMessage
                                ? " " + props.package.numberOfPerformancesMessage
                                : ""
                        }
                    </button>
                    <div className="reveal-panel" data-subs-panel aria-hidden="true" id={`Panel_package_${props.package.id}`}>
                        <ListPerformances filteredPerformances={props.packagePerformances} />
                    </div>
                </div>
            </article>
        </li>
    )
}

export default ListPackageView;